import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Tooltip } from 'antd';
import { genAvatarBgColor } from '../../utils/tools';
import UserAvatar from './UserAvatar';
import { DingtalkModule } from '@/modules/dingtalk/lazy-load';

export default function DingtalkAvatar({
    userInfo
}) {
    // Dynamic import, use it when loaded within dingtalk. see src\modules\dingtalk\lazy-load.tsx
    const {
        dingtalkAvatarDropdown,
        DINGTALK_AVATAR_MENU_MAP,
        Management,
        BindEmailDialog,
        DINGTALK_APP_ROLES,
        dingtalkFromApplyNotification
    } = DingtalkModule;

    const {
        avatar,
        full_name: name = '',
        cUserID,
        app_role: appRole,
        userEmail,
        dingtalkHasBoundEmail,
    } = userInfo || {};

    const [modalVisible, setModalVisible] = useState(false);
    const [bindEmailVisible, setBindEmailVisible] = useState(false);
    const [background] = useState(genAvatarBgColor(cUserID));
    const fromApplyNotificationInit = useRef(false);
    useEffect(() => {
        if (!appRole) return;
        if (appRole === DINGTALK_APP_ROLES.PLAIN) return;
        if (dingtalkFromApplyNotification()) {
            if (fromApplyNotificationInit.current) return;
            setModalVisible(true);
            fromApplyNotificationInit.current = true;
        }
    }, [userInfo]);

    const avatarDropdown = dingtalkAvatarDropdown.bind(null, {
        hasBoundEmail: dingtalkHasBoundEmail,
        appRole,
        name,
        onClick: (params) => {
            switch (params.key) {
                case DINGTALK_AVATAR_MENU_MAP.MANAGEMENT:
                    setModalVisible(true);
                    break;
                case DINGTALK_AVATAR_MENU_MAP.BIND_EMAIL:
                case DINGTALK_AVATAR_MENU_MAP.CHECK_EMAIL:
                    setBindEmailVisible(true);
                    break;
                default:
                    break;
            }
        }
    });

    return (
        <>
            <Tooltip overlayClassName="header-user-tooltip" placement="bottomRight" title={name}>
                {userInfo ?
                    // @ts-ignore
                    <Dropdown
                        overlay={avatarDropdown}
                        placement="bottomRight"
                        trigger={['click']}
                    >
                        <UserAvatar avatar={avatar} background={background} name={name} />
                    </Dropdown> :
                    <UserAvatar avatar={avatar} background={background} name={name} />
                }
            </Tooltip>
            {modalVisible && <Management onClose={() => setModalVisible(false)} userRole={appRole} />}
            {bindEmailVisible && <BindEmailDialog
                hasBoundEmail={dingtalkHasBoundEmail}
                email={userEmail}
                onClose={() => setBindEmailVisible(false)}
            />}
        </>
    );
}
